import React, { useContext } from 'react';
import DataRoomDocumentsProvider from './providers/DataRoomDocuments';
import DataRoomDocHeader from './components/DataRoomDocHeader';
import DragDropIcon from 'icons/DragDrop.icon';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import DataRoomSelectedDocumentsProvider from './providers/DataRoomSelectedDocuments';
import DropzoneActiveOverlay from '../DropzoneActiveOverlay';
import { DataRoomContent } from './components/DataRoomContent';
import useMatchMedia from 'hooks/useMatchMedia';
import { SecureDownloadBadge } from './components/SecureDownloadBadge';
import { DocumentsViewAsBanner } from './components/DocumentsViewAsBanner';
import CreateShareableLinkProvider from '../../providers/CreateShareableLink';
import DataRoomNodeActionsProvider from './providers/DataRoomNodeActions';
import DataRoomUploadContext from '../../providers/DataRoomUpload/DataRoomUpload.context';
import ProtectedFilesBadge from './components/ProtectedFilesBadge';

import './DataRoomDocumentsRouter.styles.scss';
import './DataRoomDocumentsRouter.styles.responsive.scss';

type DataRoomDocumentsRouterProps = {
  className?: string;
};

const DataRoomDocumentsRouter: React.FC<DataRoomDocumentsRouterProps> = (
  props,
) => {
  const { className } = props;

  const { isPublishingAllowed } = useContext(DataRoomContext);
  const { isDragActive, dropzoneContainerProps } = useContext(
    DataRoomUploadContext,
  );

  const isPhablet = useMatchMedia('isPhablet');

  const { t } = useTranslation();

  const classes = classNames(
    'data-room-documents-router',
    'white-panel',
    className,
  );

  return (
    <DataRoomDocumentsProvider>
      <DocumentsViewAsBanner />

      <DataRoomSelectedDocumentsProvider>
        <CreateShareableLinkProvider>
          <DataRoomNodeActionsProvider>
            {isPhablet && <DataRoomDocHeader />}
            <div
              className={classes}
              {...(isPublishingAllowed ? dropzoneContainerProps : {})}
            >
              <div className="dr-cont-cont">
                <DataRoomContent />
              </div>

              <DropzoneActiveOverlay isVisible={isDragActive} />

              {!isPhablet && isPublishingAllowed && (
                <small className="drop-files-info">
                  <DragDropIcon />
                  <strong>{t('tip')}: </strong>
                  {t('dragAndDropMessage')}
                </small>
              )}
            </div>

            <div className="badge-wrapper">
              <SecureDownloadBadge />
              <ProtectedFilesBadge />
            </div>
          </DataRoomNodeActionsProvider>
        </CreateShareableLinkProvider>
      </DataRoomSelectedDocumentsProvider>
    </DataRoomDocumentsProvider>
  );
};

export default DataRoomDocumentsRouter;
